import IInitializableModule from '@episerver/spa-core/Core/IInitializableModule';
import IServiceContainer from '@episerver/spa-core/Core/IServiceContainer';
import IEpiserverContext from '@episerver/spa-core/Core/IEpiserverContext';
import IStateReducerInfo from '@episerver/spa-core/Core/IStateReducerInfo';
import CellularPackageSliceReducer from './CellularPackageSlice';

export default class CellularPackageitializableModule implements IInitializableModule {
  protected name: string = 'Cellular Package  module';

  public GetName(): string {
    return this.name;
  }

  public ConfigureContainer(container: IServiceContainer): void {
    //No action taken by default
  }

  public StartModule(context: IEpiserverContext): void {
    if (context.isDebugActive()) {
      console.debug(`Starting ${this.GetName()}`);
    }
  }

  public GetStateReducer(): IStateReducerInfo<any> | null {
    return {
      stateKey: 'CellularPackage',
      reducer: CellularPackageSliceReducer,
    };
  }
}
